export const AVAILABLE_SCREENS = [
  { value: "romaneioPagamento",       label: "Status Pagamento" },
  { value: "romaneioCheckout",        label: "Checkout" },
  { value: "romaneioAntecipacao",     label: "Solicitações" },
  { value: "romaneioEstatisticas",    label: "Estatísticas" },
  { value: "romaneioEntregadores",    label: "Entregadores" },
  { value: "entregadoresMuve",        label: "Entregadores (Muve)" },
  { value: "entregadoresEntrego",     label: "Entregadores (Entrego)" },
  { value: "romaneioCadastroEntrego", label: "Gerenciar Entregadores" },
  { value: "entregoFechamento",       label: "Fechamento Semanal" },
  { value: "muveFechamento",          label: "Fechamento Muve" },
  { value: "romaneioPessoas",         label: "Checagem Pessoas" },
  { value: "indriveFechamento",       label: "Fechamento InDrive" },
  { value: "indrivePagamento",        label: "Pagamentos InDrive" },
  { value: "entregadoresImile",       label: "Entregadores (iMile)" },
  { value: "imileFechamento",         label: "Fechamento Quinzenal" },
] as const;
